import { Route } from '@angular/router';
import { RoutingID } from '../../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { TemplateSourceEntriesComponent } from '../../../../../../pages/media/template-source-entries/template-source-entries.component';
import { TemplateSourceEntryEditComponent } from '../../../../../../pages/media/template-source-entries/template-source-entry-edit/template-source-entry-edit.component';

export const templateSourceEntries: Route = {
  path: ':templateSourceID/template-source-entries',
  title: 'nav.templateSourceEntries',
  data: {
    icon: SbIcons.template,
    breadcrumb: 'nav.templateSourceEntries',
    id: RoutingID.templateSourceEntries,
  },
  children: [
    {
      path: '',
      component: TemplateSourceEntriesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'template-source-entry-edit/:templateSourceEntryID',
      title: 'nav.templateSourceEntries.edit',
      data: {
        breadcrumb: 'nav.templateSourceEntries.edit',
        icon: SbIcons.edit,
        id: RoutingID.templateSourceEntryEdit,
      },
      children: [
        {
          path: '',
          component: TemplateSourceEntryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'template-source-entry-create',
      title: 'nav.templateSourceEntries.create',
      data: {
        breadcrumb: 'nav.templateSourceEntries.create',
        icon: SbIcons.plus,
        id: RoutingID.templateSourceEntryCreate,
      },
      children: [
        {
          path: '',
          component: TemplateSourceEntryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
